import React from "react";
import Header from "../components/header.js";
import Footer from "../components/footer.js";
import Explore from "../components/home/explore.js";
import Featured from "../components/home/featured.js";
import Supporters from "../components/home/supporters.js";
import Introduction from "../components/home/introduction.js";
import FadeIn from "../components/HOC/fade-in-inview.js";

const Home = () => {
  return (
    <>
      <FadeIn>
        <Header />
      </FadeIn>
      <FadeIn>
        <Introduction />
      </FadeIn>
      <FadeIn>
        <Explore />
      </FadeIn>
      <FadeIn>
        <Featured />
      </FadeIn>
      <FadeIn>
        <Supporters />
      </FadeIn>
      <FadeIn>
        <Footer />
      </FadeIn>
    </>
  );
};

export default Home;
